import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/app/styles/components.css");
;
import(/* webpackMode: "eager" */ "/app/styles/globals.css");
